<div *ngIf="!tiles" class="flex-list-item">
  <div
    class="filebrowser-preview-icon"
    [ngClass]="{
      'filebrowser-preview-icon-image': getType(item.data.title) === 'image'
    }"
  >
    <div *ngIf="item.type == 'filefolders'">
      <nb-icon status="info" pack="far" icon="folder"></nb-icon>
    </div>
    <div *ngIf="item.type == 'files'">
      <div [ngSwitch]="getType(item.data.title)">
        <div *ngSwitchCase="'image'" class="file-image-holder">
          <img
            *ngIf="!hasError"
            (error)="this.hasError = true"
            [hidden]="!item.loaded && !hasMountedImage"
            (load)="item.loaded = true; hasMountedImage = true"
            [src]="'/' + item.type + '/' + item.id | safe"
            alt="Preview for {{ item.data.title }}"
          />
          <i
            *ngIf="!item.loaded && !hasMountedImage &&!hasError"
            class="fas fa-spinner fa-spin"
          ></i>
        </div>
        <div *ngSwitchCase="'zip'">
          <nb-icon status="info" pack="far" icon="file-archive"></nb-icon>
        </div>
        <div *ngSwitchCase="'pdf'">
          <nb-icon status="info" pack="far" icon="file-pdf"></nb-icon>
        </div>
        <div *ngSwitchCase="'doc'">
          <nb-icon status="info" pack="far" icon="file-alt"></nb-icon>
        </div>
        <div *ngSwitchDefault>
          <nb-icon status="info" pack="far" icon="file"></nb-icon>
        </div>
      </div>
    </div>
  </div>
  <div class="file-content-name">
    <div *ngIf="item.type == 'files'">
      <div *ngIf="download_url">
        <iframe style="display: none" [src]="download_url | safe"></iframe>
      </div>
      <span *ngIf="item && (item.text || item.data)">{{
        item.text || item.data.title
      }}</span>
      <i
        *ngIf="false && !item.data.canvas_id && !item.data.blackboard_id"
        class="fas fa-exclamation-triangle"
        [title]="'file_lms_not_available'| translation"
      ></i>
    </div>
    <div *ngIf="item.type == 'filefolders'">
      <a (click)="navigate(item)">{{ item.data.title }}</a>
    </div>
  </div>
  <div class="file-content-size">
    <span *ngIf="item.type == 'files'">{{ item.data.size | filesize }}</span>
  </div>
  <button
    *ngIf="item.type == 'files'"
    class="action-button"
    nbButton
    ghost
    [nbTooltip]="'view'| translation"
    (click)="
      openFile(
        $event,
        '/files/' + (item.id || item.file),
        item.text || item.data.title
      )
    "
  >
    <span><i class="fas fa-eye"></i></span>
  </button>

  <button
    *ngIf="item.type == 'files'"
    ghost
    class="action-button"
    [nbTooltip]="'download'| translation"
    nbButton
    (click)="zipFolder($event, item)"
    aria-label="Download File {{ item?.text || item?.data?.title || '' }}"
  >
  <i class="fa-light fa-file-arrow-down"></i>
  </button>

  <button
    *ngIf="item.type == 'filefolders'"
    ghost
    class="action-button"
    [nbTooltip]="'zip'| translation"
    nbButton
    (click)="zipFolder($event, item)"
    aria-label="Zip Folder {{ item?.text || item?.data?.title || '' }}"
  >
    <i class="fas fa-file-archive"></i>
  </button>

  <button
    class="action-button"
    nbButton
    ghost
    [nbTooltip]="'settings'| translation"
    (click)="openSettings($event, item)"
    *ngIf="!isDisabled"
  >
    <span><i class="fas fa-pencil-alt"></i></span>
  </button>

  <button
    class="action-button"
    nbButton
    ghost
    [nbTooltip]="'move'| translation"
    (click)="openMove($event, item)"
    *ngIf="!isDisabled"
  >
    <span><i class="fas fa-arrows-alt"></i></span>
  </button>
  <button
    class="action-button"
    nbButton
    ghost
    [nbTooltip]="'delete'| translation"
    (click)="toDelete($event, item)"
    *ngIf="!isDisabled"
  >
    <span><i class="far fa-trash-alt"></i></span>
  </button>
</div>

<div
  *ngIf="tiles"
  class="file-tile-item"
  [nbTooltip]="item.text || item.data.title"
  [class.fileBorder]="getType(item.data.title) != 'image'"
>
  <div *ngIf="item.type == 'filefolders'" class="file-preview">
    <nb-icon status="info" pack="fas" icon="folder"></nb-icon>
  </div>
  <div
    *ngIf="item.type == 'files' && getType(item.data.title) == 'image'"
    class="file-image-holder"
  >
    <img
      *ngIf="!hasError;else error"
      [hidden]="!item.loaded && !hasMountedImage"
      (error)="this.hasError = true"
      (load)="item.loaded = true; hasMountedImage = true"
      [src]="'/' + item.type + '/' + item.id | safe"
      alt="Preview for {{ item.data.title }}"
    />
    <ng-template #error>
      <div class="file-display-img-error-container">
      <i style="font-size: 32px;" #error class="fas fa-exclamation"></i>
      <label>Error Getting Image</label>
    </div>
    </ng-template>
   
    <div class="file-preview">
      <i
        *ngIf="!item.loaded && !hasMountedImage&&!hasError"
        class="fas fa-spinner fa-spin"
      ></i>
    </div>
  </div>
  <div *ngIf="item.type == 'files'">
    <div [ngSwitch]="getType(item.data.title)">
      <div *ngSwitchCase="'image'"></div>
      <div *ngSwitchCase="'zip'" class="file-preview">
        <nb-icon status="info" pack="far" icon="file-archive"></nb-icon>
      </div>
      <div *ngSwitchCase="'pdf'" class="file-preview">
        <nb-icon status="info" pack="far" icon="file-pdf"></nb-icon>
      </div>
      <div *ngSwitchCase="'doc'" class="file-preview">
        <nb-icon status="info" pack="far" icon="file-alt"></nb-icon>
      </div>
      <div *ngSwitchDefault class="file-preview">
        <nb-icon status="info" pack="far" icon="file"></nb-icon>
      </div>
    </div>
  </div>
  <div class="file-preview-button">
    <button
      *ngIf="item.type == 'filefolders'"
      [nbTooltip]="'zip'| translation"
      nbButton
      size="small"
      (click)="zipFolder($event, item)"
      aria-label="Zip Folder {{ item.text || item.data.title }}"
    >
      <i class="fas fa-file-archive"></i>
    </button>
    <button
      *ngIf="item.type == 'files'"
      [nbTooltip]="'view'| translation"
      nbButton
      size="small"
      (click)="
        openFile(
          $event,
          '/files/' + (item.id || item.file),
          item.text || item.data.title
        )
      "
      aria-label="Open preview {{ item.text || item.data.title }}"
    >
      <nb-icon pack="fas" icon="eye"></nb-icon>
    </button>

    <button
      *ngIf="item.type == 'files'"
      [nbTooltip]="'download'| translation"
      nbButton
      size="small"
      (click)="zipFolder($event, item)"
      aria-label="Download File {{ item.text || item.data.title }}"
    >
    <i class="fa-light fa-file-arrow-down"></i>
      </button>

    <button
      nbButton
      size="small"
      [nbTooltip]="'settings'| translation"
      (click)="openSettings($event, item)"
      *ngIf="!isDisabled"
    >
      <span><i class="fas fa-pencil-alt"></i></span>
    </button>
    <button
      nbButton
      size="small"
      [nbTooltip]="'move'| translation"
      (click)="openMove($event, item)"
      *ngIf="!isDisabled"
    >
      <span><i class="fas fa-arrows-alt"></i></span>
    </button>
    <button
      nbButton
      size="small"
      [nbTooltip]="'delete'| translation"
      (click)="toDelete($event, item)"
      *ngIf="!isDisabled"
    >
      <span><i class="far fa-trash-alt"></i></span>
    </button>
  </div>
  <div class="file-tile-label">
    <span
      *ngIf="
        item && (item.text || item.data) && getType(item.data.title) != 'image'
      "
      >{{ item.text || item.data.title }}</span
    >
  </div>
</div>
